import React from "react";
import PropTypes from "prop-types";
import Article from "../../../../entities/article";
import ArticleBoxThumbnail from "../../../ArticleBoxThumbnail";

function CompanyRecommendArticleBox({ article, company_name }) {
  const articleEntity = new Article({ ...article });

  const imageWidth = 210;
  const imageHeight = 120;
  const userIconUrl = articleEntity.user?.icon_url;

  return (
    <li className="l_childBox isWideInside recArticleBox">
      <a href={articleEntity.companies_path(company_name)}>
        <ArticleBoxThumbnail
          imageUrl={articleEntity.small_pic_url}
          userIconUrl={userIconUrl}
          width={imageWidth}
          height={imageHeight}
          showUserIconBackground
        />
        <div className="recommendSentence">
          <div className="recWrap">
            <span className="p_icon isGetActivityLocations">{`${
              articleEntity.display_activity_locations_small
            } ${articleEntity.user_name()}`}</span>
            <p className="recTitle">{articleEntity.title}</p>
            <span className="p_icon isGetWorkingForms">
              {articleEntity.kinds.name}
            </span>
          </div>
        </div>
      </a>
    </li>
  );
}

CompanyRecommendArticleBox.propTypes = {
  article: PropTypes.instanceOf(Article).isRequired,
  company_name: PropTypes.string.isRequired,
};

export default CompanyRecommendArticleBox;
